import React from 'react';
import ErrorTypes from 'constants/ErrorTypes';

const ALREADY_EVALUATED = 'already_evaluated';
const ALREADY_EVALUATED_MESSAGE = 'Formulár už bol vyplnený';
const EXPIRED = 'expired';
const EXPIRED_MESSAGE = 'Možnosť odoslania hodnotenia je platná iba 14 dní, ' +
'aby sme zaručili čo najväčšiu aktuálnosť a objektívnosť hodnotení.\n\n' +
'Ďakujeme Vám za záujem a dúfame, že nám odošlete hodnotenie pri ďalšej aktivite.';
const DEFAULT_ERROR_MESSAGE_GET = 'Nepodarilo sa načítať fomulár';
const DEFAULT_ERROR_MESSAGE_POST = 'Nepodarilo sa odoslať fomulár';

function ErrorMessage(props) {
    const message = getMessage(props.type, props.description);
    return (
        <div>
            {message.split('\n').map((line, i) => <p key={i}>{line}&nbsp;</p>)}
        </div>
    );
}

function getMessage(type, description) {
    switch (type) {
        case ErrorTypes.ERROR_REQUEST_GET:
        case ErrorTypes.ERROR_ID:
            return DEFAULT_ERROR_MESSAGE_GET;
        case ErrorTypes.ERROR_REQUEST_POST:
            return DEFAULT_ERROR_MESSAGE_POST;
        case ErrorTypes.ERROR_DATA_POST:
            return messageForErrorDataPost(description);
        case ErrorTypes.ERROR_DATA_GET:
            return messageForErrorDataGet(description);
        default:
            return '';
    }
}

function messageForErrorDataGet(description) {
    switch (description) {
        case ALREADY_EVALUATED:
            return ALREADY_EVALUATED_MESSAGE;
        case EXPIRED:
            return EXPIRED_MESSAGE;
        default:
            return DEFAULT_ERROR_MESSAGE_GET;
    }
}
function messageForErrorDataPost(description) {
    switch (description) {
        case ALREADY_EVALUATED:
            return ALREADY_EVALUATED_MESSAGE;
        default:
            return DEFAULT_ERROR_MESSAGE_POST;
    }
}

ErrorMessage.propTypes = {
    description: React.PropTypes.string,
    type: React.PropTypes.string.isRequired
};
ErrorMessage.defaultProps = {};
ErrorMessage.contextTypes = {};

export default ErrorMessage;



/** WEBPACK FOOTER **
 ** ./src/components/ErrorMessage.js
 **/